<mat-card class="transparent-card">
    <mat-card-header>
        <mat-card-title>Meal Counter - External View</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-form-field>
            <mat-label>Search</mat-label>
            <input matInput (keyup)="mealCounterSearch($event)">
        </mat-form-field>
        <table mat-table class="transparent-table" [dataSource]="mealCounterSource" matSort >
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                <td mat-cell *matCellDef="let badgeLog">
                    {{ badgeLog.date | date:'dd.MM.yyyy ' }}
                </td>
            </ng-container>
            <ng-container matColumnDef="total">
                <th mat-header-cell *matHeaderCellDef>Total</th>
                <td mat-cell *matCellDef="let badgeLog">
                    {{ badgeLog.total }}
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator class="transparent-paginator" [pageSizeOptions]="[25, 50, 100, 200]" showFirstLastButtons></mat-paginator>
    </mat-card-content>
</mat-card>